export default __webpack_public_path__ + "static/media/MacRA-Design_LOGO_negativo.bb5d417f.png";